module.exports = "<div class=tile id=targetlesions> <div class=tile-header> <h4>Zielläsionen</h4> </div> <div class=\"tile-body scrollable-table-wrapper\"> <target-lesions patient=$ctrl.patient></target-lesions> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp-files/modules/patients/components/tile-target-lesions/target-lesions.html
// module id = 320
// module chunks = 0